import { HttpInterceptorFn } from '@angular/common/http';
import { getStoredToken } from '../services/token-storage';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = getStoredToken();

  if (token) {
    const cloned = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
    return next(cloned);
  }

  return next(req);
};
